import { DataLakeQuery } from 'dashboard-services/api/dataLake';
import { S3Query } from 'dashboard-services/api/external';
import { CommonService } from 'dashboard-services/services';

import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';

export default(() => {
  const useSearchFiles = ({ query, provider, withStatus, shouldBeLimited, getQueryBuilder, size = CommonService.getRequestSize(), enabled = true, onSelect, shouldRefetch = true, ...rest }) => 
    useInfiniteQuery({
      ...DataLakeQuery.QUERIES.searchFiles(
        getQueryBuilder
        ,
        {
          query,
          withStatus,
          size,
          provider
        }
      ),
      initialPageParam: 0,
      refetchInterval: () => !shouldRefetch || shouldBeLimited(provider) ? undefined : 30000,
      getNextPageParam: lastPage => lastPage.totalSize > lastPage.from + (lastPage.items || []).length ? lastPage.from + (lastPage.items || []).length : undefined,
      enabled,
      select: onSelect,
      ...rest
    })

  const useUploadFileMetadata = ({ getQueryBuilder, fileName, fileType, groupName, fields, zipped, onSuccess, ...rest }) => {
    const queryClient = useQueryClient()
    return useMutation({
      ...DataLakeQuery.QUERIES.uploadFile(
        getQueryBuilder,
        {
          fileName,
          fileType,
          groupName,
          fields,
          zipped
        }
      ),
      onSuccess: response => {
        queryClient.invalidateQueries({ queryKey: DataLakeQuery.KEYS.SEARCH_FILES })
        onSuccess?.(response)
      },
      ...rest
    })
  }

  const useUploadFileContent = ({ getQueryBuilder, url, image, ...rest }) =>
    useMutation({
      ...S3Query.QUERIES.upload(
        getQueryBuilder,
        {
          url,
          image
        }
      ),
      ...rest
    })

  const useSearchFilesMutation = ({ getQueryBuilder, query, withStatus, size, provider }) =>
    useMutation({
      ...DataLakeQuery.QUERIES.searchFilesMutation(
        getQueryBuilder,
        {
          query,
          withStatus,
          size,
          provider
        }
      )
    })
  
  const useGetFileDefinitionMutation = ({ getQueryBuilder, id, ...rest }) =>
    useMutation({
      ...DataLakeQuery.QUERIES.getFileDefinitionMutation(
        getQueryBuilder,
        {
          id
        }
      ),
      ...rest
    })

  const useGetFileContentMutation = ({ getQueryBuilder, url, ...props }) =>
    useMutation({
      ...S3Query.QUERIES.getMutation(
        getQueryBuilder,
        { url }
      ),
      ...props
    })
  return {
    useSearchFiles,
    useUploadFileMetadata,
    useUploadFileContent,
    useSearchFilesMutation,
    useGetFileDefinitionMutation,
    useGetFileContentMutation
  }
})()